import { render, staticRenderFns } from "./ShowRelationshipPanelEntry.vue?vue&type=template&id=55c7e3d3&scoped=true"
import script from "./ShowRelationshipPanelEntry.vue?vue&type=script&lang=ts"
export * from "./ShowRelationshipPanelEntry.vue?vue&type=script&lang=ts"
import style0 from "./ShowRelationshipPanelEntry.vue?vue&type=style&index=0&id=55c7e3d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7e3d3",
  null
  
)

export default component.exports